import React, { useEffect } from "react";
import { Card, Button, Table, Tag, Space, Input } from "antd";
import { OrgDlg } from "./components/OrgDlg";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import { BankOutlined, WalletOutlined, EditOutlined } from "@ant-design/icons";
import { observer } from "mobx-react";
import { Store } from "../../store/Store";
import { GradeRange } from "../../components/GradeRange";
import { SortOrder } from "antd/lib/table/interface";

export const Organizations2 = observer(() => {
  const store = Store.orgsStore;

  const location = useLocation();

  const history = useHistory();
  let { id } = useParams<any>();

  useEffect(() => {
    store.onLocation(location, id);
  }, []);

  useEffect(() => {
    store.onLocation(location, id);
  }, [location.search]);

  const onPage = (page, pageSize) => {
    store.onPage(history, page, pageSize);
  };

  const onChange = (pagination, filters, sorter) => {
    store.onSort(history, sorter);
  };

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Name",
      dataIndex: "name",
      key: "name.keyword",
      // width: "30%",
      sorter: true,
      sortOrder: store.sortedInfo.columnKey === "name.keyword" ? (store.sortedInfo.order as SortOrder) : undefined,

      render: (t, r) => (
        <Space>
          <Link to={`/orgs/${r.id}/members`}>{t}</Link>
          {r.isSchool && (
            <Tag icon={<BankOutlined />} color="blue">
              School
            </Tag>
          )}
          {r.canFund && (
            <Tag icon={<WalletOutlined />} color="gold">
              Fundraising
            </Tag>
          )}
        </Space>
      ),
    },
    {
      title: "Grades",
      dataIndex: "grades",
      key: "grades",
      render: (_, r) => GradeRange(r),
    },
    // {
    //   title: "Active User Count",
    //   dataIndex: "activeUserCount",
    //   sorter: (a, b) => a.activeUserCount - b.activeUserCount,
    //   key: "count",
    // },
    {
      title: "City",
      dataIndex: "city",
      key: "city.keyword",
      sorter: true,
      sortOrder: store.sortedInfo.columnKey === "city.keyword" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state.keyword",
      sorter: true,
      sortOrder: store.sortedInfo.columnKey === "state.keyword" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    // {
    //   title: "Notes",
    //   width: "40%",
    //   dataIndex: "description",
    //   key: "description",
    //   sorter: (a, b) => (a.description || "").localeCompare(b.description),
    // },
    {
      title: "",
      key: "opt",
      render: (t, r) => (Store.isDivision ? null : <EditOutlined onClick={() => store.orgEdit.edit(r.id)} />),
    },
  ];

  return (
    <Card
      title="Organizations"
      size="small"
      bodyStyle={{ padding: 0 }}
      extra={
        <Space>
          <Input.Search
            value={store.filter.keyword}
            onChange={(e) => (store.filter.keyword = e.target.value)}
            placeholder="Search by name"
            onSearch={() => store.onSearch(history)}
          ></Input.Search>
          {Store.isDivision ? undefined : (
            <Button style={{ float: "right" }} onClick={() => store.orgEdit.edit()}>
              Add
            </Button>
          )}
          <Button loading={store.loading} style={{ float: "right" }} onClick={() => store.refresh()}>
            Refresh
          </Button>
        </Space>
      }
    >
      <Table
        size="small"
        loading={store.loading}
        onChange={onChange}
        pagination={{ ...store.pagination, onChange: onPage }}
        rowKey="id"
        columns={columns}
        dataSource={store.data.items}
      />
      {store.orgEdit.visible && <OrgDlg />}
    </Card>
  );
});
